export default {
    doctorId: state => {
        return state.doctorId;
    },
    messageType: state => {
        return state.messageType;
    },
    messageTime: state => {
        return state.messageTime;
    },
    messageTimeState: state => {
        return state.messageTimeState;
    },
    messageMobiles: state => {
        return state.messageMobiles;
    },
    message: state => {
        return state.message;
    },
    messageUnit: state => {
        return state.messageUnit;
    },
    messageValue: state => {
        return state.messageValue;
    }
}
